import gaEvents from '~js/ga-events'

const state = {
  isMobileMenuActive: false,
  isClickAvatar: false,
  isFloatMenuActive: false
}

export const getters = {
  isMobileMenuActive: state => state.isMobileMenuActive,
  isClickAvatar: state => state.isClickAvatar,
  isFloatMenuActive: state => state.isFloatMenuActive
}

export const actions = {
  showMobileMenu ({ commit, state, rootState }) {
    if (state.isMobileMenuActive === false) {
      commit('SET_MOBILE_MENU_ACTIVE', true)
      gaEvents.sendEvent('Building', 'ShowMobileMenu', rootState.route.params.buildingId || rootState.buildings.currentBuilding.objectId || '')
    }
  },

  closeMobileMenu ({ commit, state, rootState }) {
    if (state.isMobileMenuActive === true) {
      commit('SET_MOBILE_MENU_ACTIVE', false)
      gaEvents.sendEvent('Building', 'CloseMobileMenu', rootState.route.params.buildingId || rootState.buildings.currentBuilding.objectId || '')
    }
  },
  showFloatMenu ({ commit, state, rootState }) {
    if (state.isFloatMenuActive === false) {
      commit('SET_FLOAT_MENU_ACTIVE', true)
      gaEvents.sendEvent('Building', 'showFloatMenu', rootState.route.params.buildingId || rootState.buildings.currentBuilding.objectId || '')
    }
  },
  closeFloatMenu ({ commit, state, rootState }) {
    if (state.isFloatMenuActive === true) {
      commit('SET_FLOAT_MENU_ACTIVE', false)
      gaEvents.sendEvent('Building', 'closeFloatMenu', rootState.route.params.buildingId || rootState.buildings.currentBuilding.objectId || '')
    }
  },
  toggleFloatMenu ({ commit, state, rootState }) {
    state.isFloatMenuActive ? commit('SET_FLOAT_MENU_ACTIVE', false) : commit('SET_FLOAT_MENU_ACTIVE', true)
    gaEvents.sendEvent('Building', 'toggleFloatMenu', rootState.route.params.buildingId || rootState.buildings.currentBuilding.objectId || '')
  },
  changeIsClickAvatarState ({ commit }, bool) {
    commit('SET_CLICK_AVATAR', bool)
  }
}

export const mutations = {
  SET_MOBILE_MENU_ACTIVE (state, bool = false) {
    state.isMobileMenuActive = bool
  },
  SET_CLICK_AVATAR (state, bool = false) {
    state.isClickAvatar = bool
  },
  SET_FLOAT_MENU_ACTIVE (state, bool = false) {
    state.isFloatMenuActive = bool
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
